import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 -12 57.054 92.637",
  style: {"enable-background":"new 0 0 57.054 82.637"}
}

import { MatchingProgress } from '@/model/Matching'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CGenericAvatar',
  props: {
    state: { default: MatchingProgress.LOADING }
  },
  setup(__props: any) {

const props = __props

const stateClass = computed(() => {
  switch (props.state) {
    case MatchingProgress.LOADING:
      return 'loading'
    case MatchingProgress.SUCCESS:
      return 'success'
    case MatchingProgress.FAILED:
      return 'failed'
    default:
      return 'default'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      class: _normalizeClass(stateClass.value),
      d: "M56.849,72.502c0.013-0.011,0.027-0.021,0.04-0.032h-0.548c-1.873-0.129-8.272-0.71-12.797-2.826\n          c-5.351-2.502-4.103-6.071-3.994-8.899c0.109-2.829,2.718-5.875,3.604-9.267c0.629-2.408,1.544-5.663,1.544-5.663\n          s1.777-0.352,2.34-0.539c1.31-0.435,1.498-2.187,2.808-5.124c1.31-2.937,0.955-5.752,0-6.693c-0.591-0.582-1.295,0.464-2.059-0.515\n          c-0.764-0.979,0.515-4.119,0.515-4.119s1.183-0.787,4.119-0.515c2.936,0.272,4.634-1.03,4.634-1.03s-0.838-2.173-4.119-5.148\n          c-3.281-2.976-4.144-10.813-7.644-15.151c-3.501-4.338-13.844-6.746-19.22-6.962C20.695-0.198,18.329,1.474,15.587,3.5\n          c-2.742,2.026-2.064,1.59-3.838,2.157c-1.774,0.568-4.01,2.794-4.119,4.119c-0.029,0.351,0.336,1.773,0.515,2.574\n          c0.126,0.567-4.45,1.798-4.633,3.089c-0.203,1.428,1.538,2.962,1.03,3.604c-0.49,0.618-0.889,2.313-1.03,3.604\n          c-0.23,2.114,0.83,0.684,1.591,1.741s4.958,4.64,5.242,5.222c0.284,0.581-0.408,3.815-1.747,3.481s-3.262,0.086-3.495,1.741\n          c-0.233,1.655,0.979,3.918,1.747,5.222c0.768,1.304,0.972,1.854,1.747,3.481c0.775,1.627,3.495,1.741,3.495,1.741\n          s0.955,4.63,1.747,6.962c0.792,2.333,2.815,4.429,3.495,6.962c0.679,2.533,1.438,7.625-2.705,9.593C9.123,71.408,0,72.478,0,72.478\n          l0.111,0c7.723,6.347,17.608,10.159,28.384,10.159c10.761,0,20.633-3.802,28.351-10.133h0.046\n          C56.892,72.504,56.863,72.503,56.849,72.502z"
    }, null, 2)
  ]))
}
}

})